module.exports = __webpack_public_path__ + "fonts/fontello.779704d.eot";